export default __webpack_public_path__ + "static/media/52t.e3e1cca3.jpg";